import { z } from "zod";

import { NotificationEntity } from "../../../model";

import { Response } from "~/shared/api";

const zActionAsNumber = z.number().int();

const zKnownAction = NotificationEntity.zActionSchema.exclude([
  NotificationEntity.zActionSchema.Enum.UNKNOWN,
]);

const KNOWN_ACTION_BY_NUMBER = Object.fromEntries(
  [zKnownAction.Values.CREATE, zKnownAction.Values.UPDATE, zKnownAction.Values.DELETE].map(
    (value, index) => [index, value],
  ),
) as Record<number, z.infer<typeof zKnownAction>>;

function actionByNumber(value: number): NotificationEntity.Action {
  return KNOWN_ACTION_BY_NUMBER[value] ?? NotificationEntity.Action.UNKNOWN;
}

const zActionFromNumber = zActionAsNumber
  .transform((value) => actionByNumber(value))
  .pipe(NotificationEntity.zActionSchema);

const zEntityNameAsNumber = z.number().int();

const zKnownEntityName = NotificationEntity.zEntityNameSchema.exclude([
  NotificationEntity.zEntityNameSchema.Enum.UNKNOWN,
]);

const KNOWN_ENTITY_NAME_BY_NUMBER = Object.fromEntries(
  [
    zKnownEntityName.Values.ORDER,
    zKnownEntityName.Values.INQUIRY,
    zKnownEntityName.Values.NOTIFICATION,
    zKnownEntityName.Values.REVIEW,
  ].map((value, index) => [index, value]),
) as Record<number, z.infer<typeof zKnownEntityName>>;

function entityNameByNumber(value: number): NotificationEntity.EntityName {
  return KNOWN_ENTITY_NAME_BY_NUMBER[value] ?? NotificationEntity.EntityName.UNKNOWN;
}

const zEntityNameFromNumber = zEntityNameAsNumber
  .transform((value) => entityNameByNumber(value))
  .pipe(NotificationEntity.zEntityNameSchema);

const zSourceSchema = NotificationEntity.zSchema;

const zOutSchema = zSourceSchema
  .omit({
    action: true,
    entity: true,
  })
  .extend({
    entityEvent: zActionFromNumber,
    entityId: zSourceSchema.shape.entity.shape.id.nullable(),
    entityType: zEntityNameFromNumber,
    createdAt: z.string().datetime(),
  });
type OutSchema = z.infer<typeof zOutSchema>;

const zRes401 = Response.Schema.zNoBody(401);

export { zOutSchema, zRes401 };
export type { OutSchema };
